import Header from "@/types/app/header";

export default class InvestorAccountHeader {
  public static header: Header[] = [    
    {
      text: "Fund",
      align: "start",
      sortable: true,
      value: "fundName",
      class: "item-table-header item-table-header-name",
      width: ""
    },    
    {
      text: "Account Number",
      align: "start",
      sortable: true,
      value: "accountNumber",
      class: "item-table-header item-table-header-name",
      width: ""
    }, 
    {
      text: "Returned Api",
      align: "start",
      sortable: true,
      value: "returnedInWallet",
      class: "item-table-header item-table-header-fundId",
      width: ""
    },   
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
